import store from '@/store'
import { computed, Ref, onUnmounted, watch } from '@vue/composition-api'
import { pickBy } from 'lodash'
import { Cast } from '../classes'

const useCastOutputStreamDocs = (cast: Ref<Cast|null>) => {
  const castCustomRtmpDestinations = computed(() => {
    return cast.value?.custom_rtmp_destinations ?? {}
  })
  const activeSubscriptionStreamIds = new Set<string>()

  watch(castCustomRtmpDestinations, async (newVal) => {
    const newStreamIds = Object.keys(newVal ?? {})
    const newSubscriptions: Promise<void>[] = []
    newStreamIds.forEach((streamId) => {
      if (activeSubscriptionStreamIds.has(streamId)) return
      console.log('Going to subscribe to output stream:', streamId)
      newSubscriptions.push(store.dispatch.streams.subscribeStream(streamId))
      activeSubscriptionStreamIds.add(streamId)
    })
    await Promise.all(newSubscriptions)

    const staleSubscriptions: Promise<void>[] = []
    activeSubscriptionStreamIds.forEach((streamId) => {
      if (newStreamIds.includes(streamId)) return
      staleSubscriptions.push(store.dispatch.streams.unsubscribeStream(streamId))
      activeSubscriptionStreamIds.delete(streamId)
    })
    await Promise.all(staleSubscriptions)
  }, { immediate: true })

  onUnmounted(async () => {
    const staleSubscriptions: Promise<void>[] = []
    activeSubscriptionStreamIds.forEach((streamId) => {
      staleSubscriptions.push(store.dispatch.streams.unsubscribeStream(streamId))
    })
    await Promise.all(staleSubscriptions)
    activeSubscriptionStreamIds.clear()
  })

  const castOutputStreamDocs = computed(() => {
    const castStreamIds = Object.keys(castCustomRtmpDestinations.value)
    const pick = pickBy(store.state.streams.subscribedStreams, (_stream, streamId) => castStreamIds.includes(streamId))
    return pick
  })

  return {
    castOutputStreamDocs
  }
}

export default useCastOutputStreamDocs
